import script from "./Product.vue?vue&type=script&lang=ts&setup=true"
export * from "./Product.vue?vue&type=script&lang=ts&setup=true"

import "./Product.vue?vue&type=style&index=0&id=15960fe9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15960fe9"]])

export default __exports__